var _defs, _path, _path2, _path3, _path4, _path5, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewServiceGraphImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 235.014,
    height: 69.001,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newServiceGraphImg_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h2v68.5H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "newServiceGraphImg_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h2v67.5H0z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 151",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    d: "M1.06.001L1 68.501"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 154",
    fill: "none",
    stroke: "red",
    strokeWidth: 2,
    d: "M197.51 2.001L40 44.501"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 153",
    fill: "none",
    stroke: "red",
    strokeWidth: 2,
    d: "M40.001 44.501h-39"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 155",
    fill: "none",
    stroke: "red",
    strokeWidth: 2,
    d: "M235.01 2.001h-39"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 152",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    d: "M.01 68.001l235-1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 1",
    transform: "translate(37 .001)",
    clipPath: "url(#newServiceGraphImg_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 156",
    fill: "rgba(0,0,0,0)",
    stroke: "#9e9e9e",
    strokeWidth: 2,
    d: "M1 0v3M1 5v3M1 10v3M1 15v3M1 20v3M1 25v3M1 30v3M1 35v3M1 40v3M1 45v3M1 50v3M1 55v3M1 60v3M1 65v3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 2",
    transform: "translate(196.01 .501)",
    clipPath: "url(#newServiceGraphImg_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 156",
    fill: "rgba(0,0,0,0)",
    stroke: "#9e9e9e",
    strokeWidth: 2,
    d: "M1 0v3M1 5v3M1 10v3M1 15v3M1 20v3M1 25v3M1 30v3M1 35v3M1 40v3M1 45v3M1 50v3M1 55v3M1 60v3M1 65v3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewServiceGraphImg);
export default __webpack_public_path__ + "static/media/newServiceGraphImg.8c109a3befcaf163.svg";
export { ForwardRef as ReactComponent };